import { ComponentType, LazyExoticComponent, Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable =
  <T extends object>(Component: LazyExoticComponent<ComponentType<T>>) =>
  (props: T) => {
    return (
      <Suspense fallback={<Loader />}>
        <Component {...props} />
      </Suspense>
    );
  };

export default Loadable;
